import { render } from "./NotificationCategoryModal.vue?vue&type=template&id=027bba77"
import script from "./NotificationCategoryModal.vue?vue&type=script&lang=js"
export * from "./NotificationCategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__